import { FloatingController } from "@/bind/floating";

class BindController {
  alert!: FloatingController;

  init(): void {
    this.alert = new FloatingController(document.body);
    this.alert.init();
  }

  show(): void {
    this.alert.show();
  }
}

export const $bind = new BindController();
